module.exports = __webpack_public_path__ + "static/media/ct3.b5a76fa9.png";